import { IconButton, Tooltip } from "@mui/material/node";
import { useState } from 'react';
import { useTheme } from '@mui/material/styles';
import { ElementsViewDialog } from "../../Dialogs/elementsViewDialog";
import ListAltIcon from '@mui/icons-material/ListAlt';

export const ShowElementsViewButton = (props) => {
    const [showDialogOpen, setShowDialogOpen] = useState(false);
    const theme = useTheme();

    return (
        <>
            <IconButton aria-label="Refresh layout" onClick={() => { setShowDialogOpen(true); }} color="inherit" sx={{ m: 0.5 }}>
                <Tooltip title="List of all elements">
                    <ListAltIcon sx={{ color: theme.palette.menuIcon.main }} />
                </Tooltip>
            </IconButton>
            <ElementsViewDialog canvasRef={props.canvasRef} onOpen={showDialogOpen} onClose={() => { setShowDialogOpen(false) }}></ElementsViewDialog>
        </>
    );
}
